import * as api from '../../resources/dictionaries.api';
import actionTypes from './dictionaries.action-types';

export const fetchOrderStatusesDictionaryRequest = () => ({
  type: actionTypes.FETCH_ORDER_STATUSES_DICTIONARY_REQUEST,
});

export const fetchOrderStatusesDictionarySuccess = (orderStatuses) => ({
  type: actionTypes.FETCH_ORDER_STATUSES_DICTIONARY_SUCCESS,
  orderStatuses,
});

export const fetchOrderStatusesDictionaryFailure = () => ({
  type: actionTypes.FETCH_ORDER_STATUSES_DICTIONARY_FAILURE,
});

export const fetchOrderStatusesDictionary = () => async (dispatch, getState) => {
  try {
    const { session } = getState();
    const { locale } = session;

    dispatch(fetchOrderStatusesDictionaryRequest());

    const orderStatuses = await api.fetchOrderStatusesDictionary({ locale });
    dispatch(fetchOrderStatusesDictionarySuccess(orderStatuses));
  } catch (error) {
    console.error('ORDER_STATUSES_DICTIONARY', error);
    dispatch(fetchOrderStatusesDictionaryFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/actions/dictionaries/order-statuses-dictionary.actions.js